<template>
	<div style="padding: 0 10px">
		<ScanQuery @onQuery="queryCall" ph="输入批次包"> </ScanQuery>
		<el-card style="margin-bottom: 10px">
			<div class="washing__div--card1">
				<ImgView :src="productImg" :width="150" :height="150" v-if="productImg" />
				<DescCom :desc="desc" :column="2" border fw="600" fs="14px" v-if="desc"
					style="flex-shrink: 0; flex-grow: 1; margin: 0 20px">
					<template #productSku>
						<div style="display: flex; align-items: center">
							<span>{{ detail.productSku }}</span>
							<a target="_blank" style="margin-left: 5px" :href="detail?.productLink">查看商品链接</a>
							<a v-if="productCode" style="margin-left: 5px" target="_blank"
								:href="`https://s.theckb.com/ja/goods/${productCode}`">
								CKB链接
							</a>
						</div>
					</template>
				</DescCom>
			</div>
		</el-card>

		<el-card>
			<div slot="header" style="
					text-align: left;
					display: flex;
					align-items: center;
					justify-content: space-between;
				">
				<span>尺寸测量(单位:cm)</span>
				<el-tag type="danger" style="margin-left: 6px"
					v-if="isSpecialUser || is3rdSpecialUser">客户特殊需求对应，尺寸测量请先选择商品分类，并按照参考图说明进行测量项填写</el-tag>
				<div style="flex: 1; text-align: right">
					<a v-if="detail.productMeasureVideoUrl" style="margin-right: 20px"
						@click="down(detail.productMeasureVideoUrl)">下载视频</a>
				</div>
				<BatchCopySize :sizeList="is3rdSpecialUser ? thirdSubmitList : sizeList"
					v-if="!(!canChangeSize || !detail.needMeasureFlag)" :productSku="detail.productSku" :category="category"
					:item="detail" :checkSize="is3rdSpecialUser ? checkThirdSize : undefined" />
				<el-button @click="saveSize" type="primary" size="small" :disabled="!canChangeSize || !detail.needMeasureFlag"
					style="float: right; margin-left: 10px">提交</el-button>
			</div>
			<el-form class="third-measure-category" v-if="is3rdSpecialUser" v-loading="thirdConfigLoading" :inline="true"
				size="small">
				<el-form-item label="商品分类">
					<el-select v-model="category" placeholder="请选择商品分类" :disabled="!detail.needMeasureFlag"
						@change="changeThirdCategory">
						<!-- item 为新模式下可选择的商品分类配置。 -->
						<el-option v-for="item in thirdOptions" :key="item.key" :label="item.name" :value="item.key" />
					</el-select>
					<el-tooltip v-if="thirdCategoryTips" effect="dark" placement="top">
						<div slot="content" class="third-category-tips-content">
							<div v-for="(line, index) in thirdCategoryTipsLines" :key="index">{{ line || '\u00a0' }}</div>
						</div>
						<i class="el-icon-question third-category-tips"></i>
					</el-tooltip>
				</el-form-item>
				<el-form-item v-if="thirdCategoryConfig.referenceImage">
					<el-link type="primary" :underline="false" icon="el-icon-picture-outline"
						@click="openThirdImage">参考图</el-link>
				</el-form-item>
			</el-form>
			<div class="goods-cate" v-else-if="isSpecialUser">
				<span>请先选择商品分类：</span>
				<el-select v-model="category" placeholder="请选择" @change="changeSelect">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<a @click="openImage" v-if="category !== 'all'">参考图</a>
			</div>
			<el-descriptions v-if="!is3rdSpecialUser" class="margin-top size-descriptions" :column="4" size="small" border
				:labelStyle="{ flex: 1 }" :contentStyle="{ flex: 1 }">
				<el-descriptions-item v-for="i in sizeList" :key="i.code" :span="1">
					<el-form class="measureForm">
						<el-form-item :error="i.value &&
							(isNaN(i.value) || Number(i.value) == 0 || Number(i.value) < 0)
							? '请输入正确的数字'
							: ''
							">
							<el-input v-model="i.value" :disabled="!detail.needMeasureFlag"></el-input>
						</el-form-item>
					</el-form>
					<template slot="label">
						{{ i.name }}
					</template>
				</el-descriptions-item>
				<el-descriptions-item v-for="i in 4 - (sizeList.length % 4) === 4
					? 0
					: 4 - (sizeList.length % 4)" :key="i"></el-descriptions-item>
			</el-descriptions>
			<!-- 3rd专门测量 -->
			<ThirdMeasureTable v-else ref="thirdMeasureTable" :key="query.code + ':' + category" v-model="thirdMeasureResults"
				:items="thirdCategoryConfig.value || []" :disabled="!detail.needMeasureFlag" />
		</el-card>
		<el-dialog title="参考图" :visible.sync="dialogVisible" width="800px" :footer="null">
			<div><img :src="prewImage" alt="" style="width: 100%" /></div>
		</el-dialog>
	</div>
</template>

<script>
import BatchCopySize from "../components/BatchCopySize";
import ScanQuery from "@/components/ScanQuery";
import DescCom from "@/components/DescCom";
import ImgView from "@/components/ImgView";
import { editSize } from "@/apis/checking";
import { sizeList } from "./sizeList.js";
import sizeMinxin from "@/mixins/sizeMixin.js";
import { request } from "@/config/request/interceptors";
// 新测量表通过 v-model 提供可回显、可提交的测量结果。
import ThirdMeasureTable from "./ThirdMeasureTable.vue";
// 按当前分类筛选有效结果，供提交按钮和批量复制使用。
import { createMeasureResults, formatCategoryTips, hasMeasureValue } from "./thirdMeasure";
export default {
	name: "QCRequire",
	components: {
		ScanQuery,
		DescCom,
		ImgView,
		BatchCopySize,
		ThirdMeasureTable,
	},
	mixins: [sizeMinxin],
	data() {
		return {
			// 沼田 特殊测试
			isSpecialUser: false,
			// 3rd 特殊测量
			is3rdSpecialUser: false,
			// V2 接口返回的商品分类及测量控件配置。
			thirdOptions: [],
			// 配置未加载完成时禁止提交，防止丢失已有测量项。
			thirdConfigLoading: false,
			// 子组件实时同步的完整结果，也用于详情加载后的回显。
			thirdMeasureResults: [],
			dialogVisible: false,
			prewImage: "",
			productCode: "",
			category: "all",
			detail: {},
			imgUri: "",
			query: {
				code: "",
			},
			desc: "",
			specialQC: [], // String
			AdditionalItems: [],
			annex: [],
			productImg: "",
			specialCheckRequirementImgSet: [],
			specialCheckRequirementSet: [],
			abnormalShow: false,
			ingredientList: [],
			dataSource: [],
			dataSourceFromWms: [],
			productMeasureDtoList: [],
		};
	},
	computed: {
		// 新模式的 all 使用本地尺寸清单，其余分类使用接口控件配置。
		thirdCategoryConfig() {
			if (this.is3rdSpecialUser && this.category === "all") {
				return {
					// item 为本地尺寸项，保留全部编码和名称并使用单个数字输入框。
					value: sizeList.map((item) => ({
						key: item.code,
						name: item.name,
						controlType: "number",
					})),
				};
			}
			return this.thirdOptions.find((item) => item.key === this.category) || {};
		},
		// 当前分类说明，无内容时不展示问号。
		thirdCategoryTips() {
			return formatCategoryTips(this.thirdCategoryConfig.tips);
		},
		// 按行拆开，让后端 /n 在 tooltip 中真正换行。
		thirdCategoryTipsLines() {
			return this.thirdCategoryTips.split("\n");
		},
		// 仅提交当前分类的已填数据，保留逗号分隔数值及选中分支。
		thirdSubmitList() {
			return createMeasureResults(this.thirdCategoryConfig.value || [], this.thirdMeasureResults).filter(hasMeasureValue);
		},
		// 根据当前测量模式判断提交和批量复制是否可用。
		canChangeSize: function () {
			if (this.is3rdSpecialUser) {
				return this.detail?.orderCode && !this.thirdConfigLoading && this.thirdSubmitList.length > 0;
			}
			return this.detail?.orderCode && this.sizeList.some((v) => v.value);
		},
	},
	methods: {
		// 读取新模式配置；仅在 3rd 批次需要时请求，成功后复用配置。
		async loadThirdOptions() {
			if (this.thirdOptions.length || this.thirdConfigLoading) return;
			this.thirdConfigLoading = true;
			try {
				// 新分类响应包含各测量项和对应的 options 配置。
				const response = await request.wms.wms.measureGetCategoryConfigV2();
				if (response.code == 0) this.thirdOptions = response.data || [];
			} catch {
				this.$message.error("新测量配置加载失败，请重新扫描批次包");
			} finally {
				this.thirdConfigLoading = false;
			}
		},
		// 手动切换商品分类时清空前一分类的结果，避免串用测量数据。
		changeThirdCategory() {
			this.thirdMeasureResults = [];
		},
		// 复用页面已有参考图弹窗，显示新分类对应的说明图片。
		openThirdImage() {
			this.prewImage = this.thirdCategoryConfig.referenceImage;
			this.dialogVisible = true;
		},
		// 由子组件校验所选分支及所有数值，同时供批量复制调用。
		checkThirdSize() {
			return Boolean(this.$refs.thirdMeasureTable && this.$refs.thirdMeasureTable.validate());
		},
		// payload 为扫描结果；重新扫描时清除前一个批次的表单数据。
		queryCall: function (payload) {
			if (payload.code) {
				this.query.code = payload.code;
				this.detail = {};
				this.is3rdSpecialUser = false;
				this.category = "all";
				this.thirdMeasureResults = [];
				this.productMeasureDtoList = [];
				(this.specialQC = []), // String
					(this.AdditionalItems = []),
					(this.annex = []),
					(this.productImg = "");
				this.specialCheckRequirementSet = [];
				this.specialCheckRequirementImgSet = [];

				this.dataSource = [];
				(this.dataSourceFromWms = []), (this.specialCheckRequirement = []);
				this.washingLabel = true;
				this.sizes = sizeList.map((v) => {
					return {
						...v,
						value: "",
					};
				});
				this.getSizeList();
				this.getDetails();
			}
		},
		// 加载当前批次详情，并根据客户测量模式分别回显新旧表单。
		getDetails: function () {
			// 记录发起请求时的批次号，防止连续扫描后旧响应覆盖新批次。
			let params = {
				pkgCode: this.query.code,
			};
			return request.wms.wms.pkgPkgDetail(params).then(async ({ code, data }) => {
				if (code == 0 && params.pkgCode === this.query.code) {
					if (data.productType == 1) {
						// 商品详情响应提供平台商品编码。
						const res = await request.goods.product.detailBackendByProductSku({ productSku: data.productSku });
						if (res?.code == '0') {
							this.productCode = res.data?.productCode;
						}
					}
					await request.wms.wms.pkgCheckingRecord(params)
					if (params.pkgCode !== this.query.code) return;
					this.detail = data;
					this.isSpecialUser = data.sizeMeasureCustomerFlag === 1;
					this.is3rdSpecialUser = Number(data.newSizeMeasureCustomerFlag) === 1;
					this.category = data.measureCategory || (this.is3rdSpecialUser ? "" : "all");
					this.productMeasureDtoList = data.productMeasureDtoList ?? [];
					if (this.is3rdSpecialUser) {
						this.thirdMeasureResults = this.productMeasureDtoList;
						await this.loadThirdOptions();
						if (params.pkgCode !== this.query.code) return;
					} else {
						this.getSizeList();
					}
					if (!this.is3rdSpecialUser && data.productMeasureDtoList) {
						this.sizeList = this.sizeList.map((v) => {
							return {
								...v,
								value: this.productMeasureDtoList.filter(
									(y) => y.code == v.code
								).length
									? this.productMeasureDtoList.filter(
										(y) => y.code == v.code
									)[0].value
									: "",
							};
						});
					}
					this.productImg = data.productImg;
					this.desc = {
						pkgCode: {
							title: "批次包编码",
							value: data.pkgCode,
						},
						amount: {
							title: "批次数量",
							value: data.amount,
						},
						productProp: {
							title: "颜色尺码",
							value: data.productProp,
						},
						unificationCustomerFullName: {
							title: "客户名称",
							value: data.unificationCustomerFullName || "",
						},
						goodsName: {
							title: "商品名称",
							value: data.productName,
						},
						remark: {
							title: "备注信息",
							value: data.remark,
						},
						goodsType: {
							title: "商品类型",
							value:
								data.combinationProductItemFlag == 1
									? "组合商品子商品"
									: data.productType == 1
										? "普通商品"
										: data.productType == 2
											? "OEM商品"
											: data.productType == 3
												? "组合商品主商品"
												: "-",
						},
						productSku: {
							title: "平台SKU",
							value: data.productSku,
							sort: "productSku",
						},
					};
				}
			});
		},
		// 新模式提交子组件结果，旧模式继续使用原来的数值校验和请求格式。
		saveSize() {
			if (this.is3rdSpecialUser) {
				if (!this.checkThirdSize()) return false;
				return request.wms.wms.measureEditSize({
					measureCategory: this.category,
					orderCode: this.detail.orderCode,
					list: this.$refs.thirdMeasureTable.getResult(),
				}).then((res) => {
					if (res.code == 0) this.$message.success(res.msg);
				});
			}
			if (this.sizeList.some((v) => isNaN(v.value))) {
				this.$message.warning("尺寸必须是数字");
				return false;
			}
			if (this.sizeList.some((v) => v.value && Number(v.value) == 0)) {
				this.$message.warning("尺寸不能为0");
				return false;
			}
			if (this.sizeList.some((v) => v.value && Number(v.value) < 0)) {
				this.$message.warning("尺寸不能为负数");
				return false;
			}
			// 保留旧测量接口的参数和数字转换规则。
			let params = {
				measureCategory: this.category === "all" ? "" : this.category,
				orderCode: this.detail.orderCode,
				list: this.sizeList
					.filter((v) => v.value)
					.map((v) => {
						return {
							...v,
							value: Number(v.value),
						};
					}),
			};
			editSize(params).then((res) => {
				if (res.code == 0) {
					this.$message.success(res.msg);
				}
			});
		},
		down(url) {
			fetch(url)
				.then((res) => res.blob())
				.then((blob) => {
					// 将链接地址字符内容转变成blob地址
					const a = document.createElement("a");
					a.href = URL.createObjectURL(blob);
					a.download = `${this.detail.platformOrderNo}_${this.detail.productSku}`; // 下载文件的名字
					document.body.appendChild(a);
					a.click();
				});
		},
	},
	mounted() { },
};
</script>

<style scoped lang="less">
.third-measure-category {
	padding: 12px 16px;
	margin-bottom: 20px;
	background: #f5f7fa;
	border-radius: 4px;
	text-align: left;

	.el-form-item {
		margin-bottom: 0;
	}

	.el-select {
		width: 220px;
	}

	.third-category-tips {
		margin-left: 8px;
		color: #909399;
		cursor: pointer;
		font-size: 16px;
		vertical-align: middle;
	}
}

.goods-cate {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	margin-bottom: 20px;

	a {
		margin-left: 20px;
	}
}

.washing__div--card1 {
	display: flex;
	justify-content: space-between;
}
</style>
<style lang="less">
.third-category-tips-content {
	max-width: 360px;
	line-height: 18px;
	white-space: pre-wrap;

	div + div {
		margin-top: 4px;
	}
}

.measureForm .el-form-item {
	margin-bottom: 0px;
}

.size-descriptions .el-descriptions-row {
	display: flex;

	.el-descriptions-item__cell {
		border-right: 0 !important;
		border-bottom: 0 !important;
		display: flex;
		align-items: center;
	}

	.el-descriptions-item__cell:last-child {
		border-right: 1px solid #ebeef5 !important;
	}
}

.size-descriptions tbody:last-child {
	.el-descriptions-row {
		.el-descriptions-item__cell {
			border-bottom: 1px solid #ebeef5 !important;
		}
	}
}
</style>
